module.exports = __webpack_public_path__ + "img/personality.984fa2fb.svg";